import { DateTime } from 'luxon';

export type IHoursCellProps = {
  value: string;
};

export const HoursCell = (props: IHoursCellProps) => {
  const { value } = props;

  return value ? DateTime.fromISO(value).toFormat('HH:mm') : '';
};
